import React from 'react'
import { StyledSvgG } from './Icon.styled'

const IconClose = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fillRule="evenodd">
        <StyledSvgG>
          <g>
            <g>
              <path
                d="M13.414 12l7.293-7.293c.391-.39.391-1.023 0-1.414-.39-.39-1.023-.39-1.414 0L12 10.586 4.707 3.293c-.39-.39-1.023-.39-1.414 0-.39.391-.39 1.023 0 1.414L10.586 12l-7.293 7.293c-.39.391-.39 1.023 0 1.414.195.195.451.293.707.293.256 0 .512-.098.707-.293L12 13.414l7.293 7.293c.195.195.451.293.707.293.256 0 .512-.098.707-.293.391-.39.391-1.023 0-1.414L13.414 12z"
                transform="translate(-1516 -171) translate(1504 159) translate(12 12)"
              />
            </g>
          </g>
        </StyledSvgG>
      </g>
    </svg>
  )
}

export default IconClose
